export default __webpack_public_path__ + "static/media/IPad_1.237e5258.png";